module.exports = __webpack_public_path__ + "img/icon-arrow.5bba49f8.svg";